import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import useChatNavigation from "../../../../../Common/useChatNavigation";
import {
  Commas,
  getDateFormate,
} from "../../../../../Common/AllDateTimeReleventFormate";
import { bxpAcceptReject, getBxpTogether3 } from "../../../../../../redux/ots/action";
import OTSViewModel from "../../../../DashboardReceivedOrders/OrderRequests/Models/OTSViewModel";
import RentalDetailsLabel from "../../../../../Common/Label/RentalDetailsLabel";
import ProfilePic from "../../../../../../assests/imgs/Profileplaceholder.svg";
import ImageWithFallback from "../../../../../../common/ImageWithFallback";
import ProfileImageWithFallback from "../../../../../../common/ProfileImageWithFallback";

export default function PendingRequests({ postcounts }) {
  const dispatch = useDispatch();
  const { letChat } = useChatNavigation();

  const [viewmodel, setviewModel] = useState(false);
  const [type, setType] = useState("");
  const [data, setData] = useState(false);

  const togeter3 = useSelector(
    ({ ots: { bxptogetherlist3 } }) => bxptogetherlist3
  );

  useEffect(() => {
    dispatch(getBxpTogether3(3));
  }, []);

  const accept = () => { };

  const reject = () => { };

  let lastDisplayedDate = null;

  const rejectacceptbxp = (id, status) => {
    const data = {
      type: "1",
      bxp_request_id: id,
      status: status,
      countapihitformyorder: true
    };
    dispatch(bxpAcceptReject(data));
    // dispatch(getBxpTogether3(3));
    // dispatch(getBxpTogether3(3));
    // dispatch(getPostCounts(7));
  };


  return (
    <>
      <div className="posted-project umbrellaproject-sec pending-req">
        <>
          <h4>One Time Services (OTS) ({postcounts?.bxp || 0})</h4>
          {Array.isArray(togeter3?.bxp) && togeter3?.bxp?.length > 0 ? (
            <>
              {togeter3?.bxp.map((item, index) => {
                const currentDate = item.created_on.split(" ")[0];
                const shouldDisplayDate = currentDate !== lastDisplayedDate;
                lastDisplayedDate = currentDate;
                return (
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && (
                      <h6 className="date-name">
                        {getDateFormate(item.created_on)}
                      </h6>
                    )}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            {/* <img
                              src={
                                item?.cover
                                  ? item?.cover
                                  : Array.isArray(item?.files) &&
                                  item?.files[0]?.file
                              }
                              alt=""
                            /> */}
                            <ImageWithFallback url={Array.isArray(item?.files) && item?.files[0]?.file} />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>
                                ${" "}
                                {Commas(
                                  item?.total_price
                                    ? item?.total_price
                                    : item?.price
                                )}
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            {/* <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" /> */}
                            <ProfileImageWithFallback url={item?.profile_image} />

                            <div>
                              <p>
                                {item?.is_mine == 0 ? "Service Provider" : "Ordered by"}
                                <p>
                                  {" "}
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                    alt=""
                                  />{" "}
                                  {item?.rating || 0} ({item?.reviews || 0}{" "}
                                  reviews)
                                </p>
                              </p>
                              <h5>
                                {item?.first_name} {item?.last_name}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button
                              className="buttons border-button"
                              onClick={() => {
                                rejectacceptbxp(item?.id, 10);
                              }}
                            >
                              Cancel Request
                            </button>
                            <button
                              onClick={() => letChat(item)}
                              className="buttons border-button"
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                                alt=""
                              />
                            </button>
                            <button
                              className="buttons border-button"
                              onClick={() => {
                                setviewModel(true);
                                setData(item);
                                setType(1);
                              }}
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>
        <>
          <h4>Buy & Sell with Market (BSM) requests ({postcounts?.sale || 0})</h4>
          {Array.isArray(togeter3?.sale) && togeter3?.sale?.length > 0 ? (
            <>
              {togeter3?.sale.map((item, index) => {
                const currentDate = item.created_on.split(" ")[0];
                const shouldDisplayDate = currentDate !== lastDisplayedDate;
                lastDisplayedDate = currentDate;
                return (
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && (
                      <h6 className="date-name">
                        {getDateFormate(item.created_on)}
                      </h6>
                    )}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            {/* <img
                              src={
                                item?.cover
                                  ? item?.cover
                                  : Array.isArray(item?.files) &&
                                  item?.files[0]?.file
                              }
                              alt=""
                            /> */}
                            <ImageWithFallback url={Array.isArray(item?.files) && item?.files[0]?.file} />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>
                                ${" "}
                                {Commas(
                                  item?.total_price
                                    ? item?.total_price
                                    : item?.price
                                )}
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            {/* <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" /> */}
                            <ProfileImageWithFallback url={item?.profile_image} />
                            <div>
                              <p>
                                {item?.is_mine == 0 ? "Seller" : "Ordered by"}
                                <p>
                                  {" "}
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                    alt=""
                                  />{" "}
                                  {item?.rating || 0} ({item?.reviews || 0}{" "}
                                  reviews)
                                </p>
                              </p>
                              <h5>
                                {item?.first_name} {item?.last_name}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button
                              onClick={() => letChat(item)}
                              className="buttons border-button"
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                                alt=""
                              />
                            </button>
                            <button
                              className="buttons border-button"
                              onClick={() => {
                                setviewModel(true);
                                setData(item);
                                setType(2);
                              }}
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>
        <>
          <h4>Turn Assets to Income (TAI) requests ({postcounts?.rental || 0})</h4>
          {Array.isArray(togeter3?.rental) && togeter3?.rental?.length > 0 ? (
            <>
              {togeter3?.rental.map((item, index) => {
                const currentDate = item.created_on.split(" ")[0];
                const shouldDisplayDate = currentDate !== lastDisplayedDate;
                lastDisplayedDate = currentDate;
                return (
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && (
                      <h6 className="date-name">
                        {getDateFormate(item.created_on)}
                      </h6>
                    )}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            <ImageWithFallback url={Array.isArray(item?.files) && item?.files[0]?.file} />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>
                                ${" "}
                                {Commas(
                                  item?.total_price
                                    ? item?.total_price
                                    : item?.price
                                )}
                              </h3>
                              <RentalDetailsLabel item={item} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            {/* <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" /> */}
                            <ProfileImageWithFallback url={item?.profile_image} />
                            <div>
                              <p>
                                {item?.is_mine == 0 ? "Owner" : "Ordered by"}
                                <p>
                                  {" "}
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                    alt=""
                                  />{" "}
                                  {item?.rating || 0} ({item?.reviews || 0}{" "}
                                  reviews)
                                </p>
                              </p>
                              <h5>
                                {item?.first_name} {item?.last_name}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button
                              onClick={() => letChat(item)}
                              className="buttons border-button"
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                                alt=""
                              />
                            </button>
                            <button
                              className="buttons border-button"
                              onClick={() => {
                                setviewModel(true);
                                setData(item);
                                setType(3);
                              }}
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>
        <div
          className={`teamviewdetail w-100 ${viewmodel == true ? "show" : ""}`}
          isOpen={viewmodel}
        >
          <OTSViewModel
            type={type}
            accept={accept}
            reject={reject}
            data={data}
            setviewModel={setviewModel}
            your={"no"}
          />
        </div>
      </div>
    </>
  );
}
